import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

export default function testimonials() {
  const sections = document.querySelectorAll('.testimonials')
  if (!sections) return;
  sections.forEach(section => {
    const swiper = new Swiper(section.querySelector('.swiper'), {
      slidesPerView: 1.125,
      spaceBetween: 16,
      autoHeight: true,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        500: {
          slidesPerView: 1.25,
        },
        768: {
          slidesPerView: 1.5,
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 2.25,
        },
        1280: {
          slidesPerView: 2.5,
        },
        1920: {
          slidesPerView: 3.5,
        }
      },
      modules: [Navigation],
    })
  });
}